import {createSlice, createAction, createEntityAdapter, createSelector} from "@reduxjs/toolkit";

export const generateUpdateSourceTextAction = createAction("translationModel/generateUpdateSourceTextAction")
const translationAdapter = createEntityAdapter({
  selectId: (segment) => segment.segmentId,
});
const initModel = {
  translationModel: {
    sourceLanguageId: 0,
    targetLanguageId: 0,
    putTargetOnError: true,
    semgments: [],
    engine: 0,
    isTargetLangSelected: false,
  },
  isUpdating: true,
};
const translationModelSlice = createSlice({
  name: "translationModel",
  initialState: translationAdapter.getInitialState({sourceLanguageId: 0,targetLanguageId: 0,  putTargetOnError: true, semgments: [],engine: 0, isTargetLangSelected: false, isUpdating: true}),
  reducers: {
    updateModel: (state, action) => {
      state.translationModel = action.payload;
      state.isUpdating = false;
    },
    modelIsLoading: (state) => {
      state.isUpdating = true;
    },
    updateSourceLanguageId: (state, action) => {
      state.sourceLanguageId = action.payload;
      state.isTargetLangSelected = true;
    },
    updateSourceText: (state, action) => {
      state.targetLanguageId = action.payload.targetId;
      state.isTargetLangSelected = true;
      translationAdapter.addMany(state, action.payload.sourceText)
      state.isUpdating = false;
    }
    // updateSourceText: (state, action) => {
    //   state.translationModel.semgments = action.payload.sourceText;
    //   state.translationModel.targetLanguageId = action.payload.targetId;
    //   state.translationModel.isTargetLangSelected = true;
    //   state.isUpdating = false;
    // },
  }
})

//Selectors
export const selectTranslationModel = createSelector(
    (state) => state.translationModel,
    (translationModel) => translationModel
)

export default  translationModelSlice.reducer;
export const {updateModel, modelIsLoading, updateSourceLanguageId, updateSourceText} = translationModelSlice.actions;